import { useParams } from 'react-router-dom'
import ErrorStyle from './index.module.css'
// console.log(ErrorStyle)
import defaultImg from '../../assets/images/default.png'
const ErrorPage = ()=>{
    const params = useParams()
    return <>
    <div className={ErrorStyle['error-cover']}>
        <div className={ErrorStyle['modal']}>
            <img className={ErrorStyle['default-img']} src={defaultImg} alt='defaultImg'/>
            <div>{params.msg||'Opps，something goes wrong! Please try again alter.'}</div>
            {/* <div className={ErrorStyle['btn-cover']}>
                <div className={ErrorStyle['btn']}>关闭</div>
            </div> */}
       </div>
    </div>
    </>
}
export default ErrorPage